module.exports = __webpack_public_path__ + "static/media/Categories.19949cf7.svg";